import { CarTypeMonthlyStats, EvCarMonthlyStats, EvExternalChargingRatios } from "@/models/monthlyCarStats";
import { AxiosResponse } from "axios";
import { httpClient } from "./API";

export const getEvExternalChargingRatiosAPI = async (
  officeId: number,
  yyyymm: string,
): Promise<AxiosResponse<EvExternalChargingRatios>> => {
  return httpClient.get("/core/internal/calgary/monthlyCarStats/externalChargingRatios", {
    params: { officeId, yyyymm },
  });
};

export const getCarTypeMonthlyStatsAPI = async (
  officeId: number,
  yyyymm: string,
): Promise<AxiosResponse<CarTypeMonthlyStats>> => {
  return httpClient.get("/core/internal/calgary/monthlyCarStats/carTypeStats", {
    params: { officeId, yyyymm },
  });
};

export const getEvCarMonthlyStatsAPI = async (
  officeId: number,
  yyyymm: string,
): Promise<AxiosResponse<EvCarMonthlyStats>> => {
  return httpClient.get("/core/internal/calgary/monthlyCarStats/evCarStats", {
    params: { officeId, yyyymm },
  });
};
